(() => {
  const money = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'ar', { style: 'currency', currency: currency || window.Shopify?.currency?.active || 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format((Number(cents) || 0) / 100);
    } catch (_error) {
      return `${Math.ceil((Number(cents) || 0) / 100)} ${currency || 'EUR'}`;
    }
  };

  class PiltronProductPage {
    constructor(root) {
      if (root.dataset.piltronProductInitialized === 'true') return;
      root.dataset.piltronProductInitialized = 'true';
      this.root = root;
      window.PILTRONPricingUI?.scan(root);
      this.form = root.querySelector('[data-piltron-product-form]');
      this.singleForm = root.querySelector('[data-piltron-single-form]');
      this.singleSubmit = root.querySelector('[data-piltron-single-submit]');
      this.singleMessage = root.querySelector('[data-piltron-single-message]');
      this.message = root.querySelector('[data-piltron-message]');
      this.submit = root.querySelector('[data-piltron-submit]');
      this.variantInput = root.querySelector('[data-piltron-variant-id]');
      this.variantAvailable = !((this.submit || this.singleSubmit)?.disabled);
      this.currentVariantPrice = Number(root.dataset.initialPrice) || 0;
      this.currentVariantSku = '';
      this.physicalUnits = Math.max(1, Number(root.dataset.physicalUnits) || 1);
      this.variantRequest = 0;
      this.giftReady = root.dataset.giftReady === 'true';
      this.giftVariantId = Number(root.dataset.giftVariantId) || 0;
      this.giftPrice = Number(root.dataset.giftPrice) || 0;
      this.giftToggle = root.querySelector('[data-piltron-gift-toggle]');
      this.giftFields = root.querySelector('[data-piltron-gift-fields]');
      this.giftMessage = root.querySelector('[data-piltron-gift-message]');
      this.giftPhoto = root.querySelector('[data-piltron-gift-photo]');
      this.giftStatus = root.querySelector('[data-piltron-gift-status]');
      try { this.variants = JSON.parse(root.querySelector('[data-piltron-variants-json]')?.textContent || '[]'); }
      catch (_error) { this.variants = []; }
      const initialVariant = this.variants.find((item) => String(item.id) === String(this.variantInput?.value || this.singleForm?.querySelector('[name=id]')?.value || '')) || this.variants[0];
      this.currentVariantSku = initialVariant?.sku || '';
      try { this.variantFactoryNames = JSON.parse(root.querySelector('[data-piltron-variant-factory-json]')?.textContent || '{}'); }
      catch (_error) { this.variantFactoryNames = {}; }
      try { this.variantMediaIds = JSON.parse(root.querySelector('[data-piltron-variant-media-json]')?.textContent || '{}'); }
      catch (_error) { this.variantMediaIds = {}; }
      const initialCfg = initialVariant?.sku ? window.PILTRON_PRICING_PUBLIC?.[initialVariant.sku] : null;
      if (initialCfg?.p) this.physicalUnits = Math.max(1, Number(initialCfg.p) || 1);

      this.gallery = root.querySelector('.piltron-product-main__gallery');
      this.mediaItems = Array.from(root.querySelectorAll('[data-piltron-media-id]'));
      this.mediaButtons = Array.from(root.querySelectorAll('[data-piltron-media-button]'));
      this.mediaCounterCurrent = root.querySelector('[data-piltron-media-current]');
      this.currentMediaIndex = Math.max(0, this.mediaItems.findIndex((item) => !item.hidden));
      this.bindMobileGallerySwipe();
      this.showMedia(this.currentMediaIndex, false);

      root.addEventListener('click', (event) => this.handleClick(event));
      root.addEventListener('change', (event) => this.handleChange(event));
      this.giftToggle?.addEventListener('change', () => {
        if (this.giftFields) this.giftFields.hidden = !this.giftToggle.checked;
        if (!this.giftToggle.checked && this.giftPhoto) this.giftPhoto.value = '';
        if (this.giftStatus) this.giftStatus.textContent = '';
        this.updateTotal();
      });
      this.giftPhoto?.addEventListener('change', () => this.validateGiftPhoto());
      root.addEventListener('input', (event) => {
        if (event.target.matches('[data-piltron-quantity], [data-addon-quantity]')) this.updateTotal();
      });
      this.form?.addEventListener('submit', (event) => this.handleSubmit(event));
      this.singleForm?.addEventListener('submit', (event) => this.handleSingleSubmit(event));
      this.updateTotal();
    }

    handleClick(event) {
      const thumb = event.target.closest('[data-piltron-media-button]');
      if (thumb && this.root.contains(thumb)) {
        const index = this.mediaButtons.indexOf(thumb);
        if (index >= 0) this.showMedia(index);
        return;
      }
      const quantity = this.root.querySelector('[data-piltron-quantity]');
      if (!quantity) return;
      if (event.target.closest('[data-piltron-quantity-minus]')) {
        quantity.value = String(Math.max(1, (Number(quantity.value) || 1) - 1));
        this.updateTotal();
      } else if (event.target.closest('[data-piltron-quantity-plus]')) {
        const max = Number(quantity.max) || Number.POSITIVE_INFINITY;
        quantity.value = String(Math.min(max, Math.max(1, (Number(quantity.value) || 1) + 1)));
        this.updateTotal();
      } else if (event.target.closest('[data-addon-increase], [data-addon-decrease]')) {
        this.updateTotal();
      }
    }

    showMedia(index, scrollThumb = true) {
      if (!this.mediaItems.length) return;
      const total = this.mediaItems.length;
      const nextIndex = ((Number(index) || 0) % total + total) % total;
      this.currentMediaIndex = nextIndex;

      this.mediaItems.forEach((item, i) => { item.hidden = i !== nextIndex; });
      this.mediaButtons.forEach((button, i) => {
        const active = i === nextIndex;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (this.mediaCounterCurrent) this.mediaCounterCurrent.textContent = String(nextIndex + 1);

      if (scrollThumb && this.mediaButtons[nextIndex]) {
        this.mediaButtons[nextIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    bindMobileGallerySwipe() {
      if (!this.gallery || this.mediaItems.length <= 1) return;

      let startX = 0;
      let startY = 0;
      let startTime = 0;

      this.gallery.addEventListener('touchstart', (event) => {
        if (event.touches.length !== 1) return;
        const touch = event.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
        startTime = Date.now();
      }, { passive: true });

      this.gallery.addEventListener('touchend', (event) => {
        if (!startTime || event.changedTouches.length !== 1) return;
        const touch = event.changedTouches[0];
        const dx = touch.clientX - startX;
        const dy = touch.clientY - startY;
        const elapsed = Date.now() - startTime;
        startTime = 0;

        // Only treat a clear horizontal finger gesture as a gallery swipe.
        if (elapsed > 900 || Math.abs(dx) < 42 || Math.abs(dx) <= Math.abs(dy) * 1.15) return;

        if (dx < 0) this.showMedia(this.currentMediaIndex + 1);
        else this.showMedia(this.currentMediaIndex - 1);
      }, { passive: true });
    }

    handleChange(event) {
      if (this.singleForm && event.target.matches('[data-piltron-single-option-index]')) {
        this.handleSingleVariantChange(event);
        return;
      }
      if (event.target.matches('[data-piltron-quantity]')) {
        const max = Number(event.target.max) || Number.POSITIVE_INFINITY;
        event.target.value = String(Math.min(max, Math.max(1, Number(event.target.value) || 1)));
        this.updateTotal();
        return;
      }
      if (!event.target.matches('[data-piltron-option-value]')) return;
      const selectedOptions = Array.from(this.root.querySelectorAll('[data-piltron-option-index]')).map((fieldset) => fieldset.querySelector('[data-piltron-option-value]:checked')?.value || '');
      const variant = this.variants.find((item) => Array.isArray(item.options) && item.options.every((value, index) => value === selectedOptions[index]));
      if (variant) this.selectVariant(variant);
    }

    handleSingleVariantChange(event) {
      const controls = [...this.root.querySelectorAll('[data-piltron-single-option-index]')];
      const changedIndex = Number(event.target.dataset.piltronSingleOptionIndex);
      const wanted = controls.map(control => control.value);
      let variant = this.variants.find(item => item.options.every((value, index) => value === wanted[index]));
      // A colour change can require a different available pack size. Keep the exact
      // combination whenever it exists; otherwise choose a pack in that colour.
      if (!variant && changedIndex === 0) {
        const matchingColour = this.variants.filter(item => item.options[0] === wanted[0]);
        variant = matchingColour.find(item => item.available) || matchingColour[0];
      }
      const status = this.root.querySelector('[data-piltron-variant-status]');
      const locale = (document.documentElement.lang || 'ar').slice(0, 2);
      const words = locale === 'ar'
        ? { unavailable: 'هذا الاختيار غير متاح حاليًا.', changed: 'تم تحديث الحجم أو عدد القطع ليتوافق مع اللون المختار.' }
        : locale === 'de'
          ? { unavailable: 'Diese Variante ist derzeit nicht verfügbar.', changed: 'Größe oder Packungsinhalt wurde an die gewählte Farbe angepasst.' }
          : { unavailable: 'This option is currently unavailable.', changed: 'The size or pack size has been updated to match the selected colour.' };
      const input = this.singleForm.querySelector('[name="id"]');
      if (!variant) {
        input.value = '';
        this.variantAvailable = false;
        this.singleSubmit.disabled = true;
        if (status) status.textContent = words.unavailable;
        return;
      }
      const sizeChanged = controls.some((control, index) => index > 0 && control.value !== variant.options[index]);
      controls.forEach((control, index) => { control.value = variant.options[index]; });
      controls.forEach((control, index) => {
        if (index === 0) return;
        for (const option of control.options) {
          option.disabled = !this.variants.some(item => item.options[index] === option.value && item.options.slice(0, index).every((value, previousIndex) => value === controls[previousIndex].value));
        }
      });
      input.value = String(variant.id);
      this.currentVariantSku = variant.sku || '';
      this.currentVariantPrice = Number(variant.price) || 0;
      const cfg = window.PILTRON_PRICING_PUBLIC?.[this.currentVariantSku];
      this.physicalUnits = Math.max(1, Number(cfg?.p) || Number(this.root.dataset.physicalUnits) || 1);
      this.variantAvailable = Boolean(Number(variant.price) > 0 && variant.available);
      this.singleSubmit.disabled = !this.variantAvailable;
      if (status) status.textContent = !this.variantAvailable ? words.unavailable : sizeChanged ? words.changed : '';
      const priceBlock = this.root.querySelector('[data-piltron-starting-price-block]');
      if (priceBlock && window.PILTRONPricingUI?.updateBlock) window.PILTRONPricingUI.updateBlock(priceBlock, this.currentVariantSku);
      const factory = this.root.querySelector('.piltron-names--product .piltron-names__factory');
      if (factory && this.variantFactoryNames?.[String(variant.id)]) factory.textContent = this.variantFactoryNames[String(variant.id)];
      const mediaId = this.variantMediaIds?.[String(variant.id)] || variant.featured_media?.id;
      const mediaIndex = this.mediaItems.findIndex(item => String(item.dataset.piltronMediaId) === String(mediaId));
      if (mediaIndex >= 0) this.showMedia(mediaIndex);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.history.replaceState({}, '', url);
      this.setSingleMessage('', '');
    }


    selectVariant(variant) {
      if (this.variantInput) this.variantInput.value = String(variant.id);
      this.currentVariantPrice = Number(variant.price) || 0;
      this.currentVariantSku = variant.sku || '';
      const price = this.root.querySelector('[data-piltron-price]');
      const cfg = variant.sku ? window.PILTRON_PRICING_PUBLIC?.[variant.sku] : null;
      if (cfg?.p) this.physicalUnits = Math.max(1, Number(cfg.p) || 1);
      const startingBlock = price?.querySelector('[data-piltron-starting-price-block]');
      if (startingBlock && window.PILTRONPricingUI?.updateBlock) window.PILTRONPricingUI.updateBlock(startingBlock, variant.sku);
      else if (price) {
        const isBundle = String(variant.sku || '').startsWith('PLT-BND-');
        if (isBundle) {
          price.textContent = money(Number(variant.price));
        } else {
          const locale = (document.documentElement.lang || 'ar').slice(0, 2).toLowerCase();
          const label = locale === 'de' ? 'Ab' : (locale === 'en' ? 'From' : 'يبدأ من');
          const direction = locale === 'ar' ? 'rtl' : 'ltr';
          price.innerHTML = `<span class="piltron-starting-price" dir="${direction}"><span data-piltron-price-label dir="${direction}">${label}</span><span data-piltron-starting-value dir="ltr"></span></span>`;
          const value = price.querySelector('[data-piltron-starting-value]');
          if (value) value.textContent = money(variant.price);
        }
      }
      const variantReady = Boolean(
        Number(variant.price) > 0 &&
        (variant.available || variant.inventory_policy === 'continue' || variant.inventory_management === null || Number(variant.inventory_quantity) > 0)
      );
      if (this.submit) this.submit.disabled = !variantReady;
      this.variantAvailable = variantReady;
      const submitText = this.root.querySelector('[data-piltron-submit-text]');
      if (submitText) submitText.textContent = variantReady ? 'أضف إلى السلة' : 'الباقة غير متاحة حاليًا';
      const addons = this.root.querySelector('piltron-bundle-addons');
      if (addons) {
        addons.reset?.();
        addons.dataset.selectedVariantId = String(variant.id);
        addons.hidden = false;
        addons.setAttribute('aria-busy', 'true');
        addons.querySelectorAll('[data-addon-panel]').forEach((panel) => { panel.hidden = true; });
        const status = addons.querySelector('[data-addon-status]');
        if (status) status.textContent = 'جاري تحميل منتجات النسخة المختارة…';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      this.updateTotal();
      if (addons) this.refreshAddons(variant.id);
    }

    async refreshAddons(variantId) {
      const addons = this.root.querySelector('piltron-bundle-addons');
      if (!addons) return;

      const requestId = ++this.variantRequest;
      const sectionId = addons.dataset.sectionId;
      const productUrl = addons.dataset.productUrl || window.location.pathname;
      const url = new URL(productUrl, window.location.origin);
      url.searchParams.set('variant', variantId);
      url.searchParams.set('section_id', sectionId);
      const previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id') || sessionStorage.getItem('piltron_preview_theme_id');
      if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);

      try {
        const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('تعذّر تحميل منتجات النسخة المختارة');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const freshAddons = html.querySelector('piltron-bundle-addons');
        if (requestId !== this.variantRequest || !freshAddons) throw new Error('تعذّر تحميل منتجات النسخة المختارة');

        addons.innerHTML = freshAddons.innerHTML;
        addons.dataset.selectedVariantId = String(variantId);
        addons.refreshPanel?.(String(variantId));
        addons.removeAttribute('aria-busy');
        this.updateTotal();
      } catch (error) {
        if (requestId !== this.variantRequest) return;
        addons.hidden = false;
        addons.removeAttribute('aria-busy');
        const status = addons.querySelector('[data-addon-status]');
        if (status) status.textContent = error?.message || 'تعذّر تحميل المنتجات. اختَر النسخة مرة أخرى.';
      }
    }

    validateGiftPhoto() {
      const file = this.giftPhoto?.files?.[0];
      if (!file || file.size <= 10 * 1024 * 1024) return true;
      this.giftPhoto.value = '';
      if (this.giftStatus) this.giftStatus.textContent = 'حجم الصورة يجب ألا يتجاوز 10 MB.';
      return false;
    }

    bundleInstanceToken() {
      if (window.crypto?.randomUUID) return window.crypto.randomUUID();
      return `plt-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    }

    async addGiftService(quantity, parentId, bundleInstance) {
      if (!this.giftToggle?.checked) return;
      if (!this.giftReady || !this.giftVariantId || !this.giftPrice) throw new Error('خدمة تغليف الهدية غير متاحة حاليًا');
      if (!this.validateGiftPhoto()) throw new Error('راجع صورة الهدية ثم حاول مرة أخرى');

      const formData = new FormData();
      formData.append('id', String(this.giftVariantId));
      formData.append('quantity', String(quantity));
      formData.append('properties[_piltron_gift_wrap]', 'true');
      formData.append('properties[_piltron_bundle_instance]', bundleInstance);
      formData.append('properties[_piltron_parent_variant]', String(parentId));
      const message = this.giftMessage?.value?.trim() || '';
      const photo = this.giftPhoto?.files?.[0];
      if (message) formData.append('properties[رسالة الهدية]', message);
      if (photo) formData.append('properties[صورة الهدية]', photo, photo.name);

      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
        credentials: 'same-origin',
      });
      const payload = await response.json();
      if (!response.ok || payload.status) throw new Error(payload.description || payload.message || 'تعذر إضافة تغليف الهدية');
    }

    async rollbackBundleInstance(bundleInstance) {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
        if (!response.ok) return;
        const cart = await response.json();
        const updates = {};
        (cart.items || []).forEach((item) => {
          if (item.properties?._piltron_bundle_instance === bundleInstance && item.key) updates[item.key] = 0;
        });
        if (!Object.keys(updates).length) return;
        await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates }), credentials: 'same-origin'
        });
      } catch (_error) {}
    }

    updateTotal() {
      const total = this.root.querySelector('[data-piltron-total]');
      if (!total) return;

      const bundleQuantity = Math.max(1, Number(this.root.querySelector('[data-piltron-quantity]')?.value) || 1);
      const giftUnitPrice = this.giftToggle?.checked ? this.giftPrice : 0;
      const cfg = this.currentVariantSku ? window.PILTRON_PRICING_PUBLIC?.[this.currentVariantSku] : null;
      const publicUnitPrice = window.PILTRONPricingUI?.publicCents
        ? window.PILTRONPricingUI.publicCents({ sku: this.currentVariantSku, price: this.currentVariantPrice })
        : this.currentVariantPrice;
      // Add-on prices stay hidden on the bundle page; their discount is applied in the cart.
      const isBundle = cfg?.mode === 'bundle' || String(this.currentVariantSku || '').startsWith('PLT-BND-');
      if (isBundle) total.textContent = money((publicUnitPrice + giftUnitPrice) * bundleQuantity);
      else {
        const lang = (document.documentElement.lang || 'ar').slice(0, 2).toLowerCase();
        const fromLabel = lang === 'de' ? 'Ab' : lang === 'en' ? 'From' : 'يبدأ من';
        total.textContent = `${fromLabel} ${money(publicUnitPrice * bundleQuantity)}`;
      }
    }

    async refreshCartBubble() {
      try {
        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        });
        if (!cartResponse.ok) return null;
        const cart = await cartResponse.json();
        document.querySelectorAll('cart-icon').forEach((icon) => {
          if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(Number(cart.item_count) || 0);
        });
        return cart;
      } catch (_cartUiError) {
        return null;
      }
    }

    setSingleMessage(text, state) {
      if (!this.singleMessage) return;
      this.singleMessage.textContent = text;
      this.singleMessage.dataset.state = state;
    }

    async handleSingleSubmit(event) {
      event.preventDefault();
      if (!this.singleForm || this.singleSubmit?.disabled) return;

      const formData = new FormData(this.singleForm);
      const id = Number(formData.get('id')) || 0;
      const quantity = Math.max(1, Number(formData.get('quantity')) || 1);
      if (!id) return;

      this.setSingleMessage('جاري الإضافة إلى السلة…', 'busy');
      if (this.singleSubmit) this.singleSubmit.disabled = true;

      const items = [{
        id,
        quantity,
        properties: { _piltron_physical_units: String(this.physicalUnits) },
      }];

      try {
        if (window.PiltronOrderLimits?.validateItems) {
          const validation = await window.PiltronOrderLimits.validateItems(items);
          if (!validation.ok) throw new Error(validation.message);
        }

        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items }),
          credentials: 'same-origin',
        });
        const payload = await response.json();
        if (!response.ok || payload.status) throw new Error(payload.description || payload.message || 'تعذر إضافة المنتج');

        await this.refreshCartBubble();
        this.setSingleMessage('تمت الإضافة إلى السلة. يمكنك متابعة التسوق أو الذهاب إلى السلة.', 'success');
      } catch (error) {
        this.setSingleMessage(error?.message || 'تعذر إضافة المنتج. حاول مرة أخرى.', 'error');
      } finally {
        if (this.singleSubmit) this.singleSubmit.disabled = !this.variantAvailable;
      }
    }

    async handleSubmit(event) {
      event.preventDefault();
      if (!this.variantInput?.value || !this.variantAvailable) return;
      this.setMessage('جاري إضافة الباقة إلى السلة…', 'busy');
      if (this.submit) this.submit.disabled = true;
      const quantity = Math.max(1, Number(this.root.querySelector('[data-piltron-quantity]')?.value) || 1);
      const parentId = Number(this.variantInput.value);
      const addons = this.root.querySelector('piltron-bundle-addons')?.getSelectedItems?.() || [];
      const bundleInstance = this.bundleInstanceToken();
      if (this.giftToggle?.checked && !this.validateGiftPhoto()) {
        if (this.submit) this.submit.disabled = !this.variantAvailable;
        return;
      }
      const items = [
        { id: parentId, quantity, properties: { _piltron_bundle: 'true', _piltron_bundle_instance: bundleInstance, _piltron_physical_units: String(this.physicalUnits) } },
        ...addons.map((addon) => ({ id: Number(addon.variantId), quantity: Number(addon.quantity) * quantity, parent_id: parentId, properties: { _piltron_bundle_addon: 'true', _piltron_parent_variant: String(parentId), _piltron_bundle_instance: bundleInstance, _piltron_physical_units: '1' } })),
      ];
      try {
        if (window.PiltronOrderLimits?.validateItems) {
          const validation = await window.PiltronOrderLimits.validateItems(items);
          if (!validation.ok) throw new Error(validation.message);
        }
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }), credentials: 'same-origin' });
        const payload = await response.json();
        if (!response.ok || payload.status) throw new Error(payload.description || payload.message || 'تعذر إضافة الباقة');
        try {
          await this.addGiftService(quantity, parentId, bundleInstance);
        } catch (giftError) {
          await this.rollbackBundleInstance(bundleInstance);
          throw giftError;
        }
        this.root.querySelector('piltron-bundle-addons')?.reset?.();
        if (this.giftToggle) this.giftToggle.checked = false;
        if (this.giftFields) this.giftFields.hidden = true;
        if (this.giftMessage) this.giftMessage.value = '';
        if (this.giftPhoto) this.giftPhoto.value = '';
        this.updateTotal();
        this.setMessage('تمت الإضافة إلى السلة بنجاح. يمكنك متابعة التسوق وإضافة منتجات أخرى.', 'success');

        // Stay on the product page after adding; only refresh the cart count.
        await this.refreshCartBubble();

        if (this.submit) this.submit.disabled = !this.variantAvailable;
      } catch (error) {
        this.setMessage(error?.message || 'تعذر إضافة الباقة. راجع المخزون ثم حاول مرة أخرى.', 'error');
        if (this.submit) this.submit.disabled = !this.variantAvailable;
      }
    }

    setMessage(text, state) {
      if (!this.message) return;
      this.message.textContent = text;
      this.message.dataset.state = state;
    }
  }

  document.querySelectorAll('[data-product-section-id]').forEach((root) => new PiltronProductPage(root));
  document.addEventListener('piltron:product:replace', event => new PiltronProductPage(event.detail.root));
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll?.('[data-product-section-id]').forEach((root) => new PiltronProductPage(root)));
})();
